import { render, staticRenderFns } from "./DetailsProgress.vue?vue&type=template&id=2b5debc2&scoped=true"
import script from "./DetailsProgress.vue?vue&type=script&lang=js"
export * from "./DetailsProgress.vue?vue&type=script&lang=js"
import style0 from "./DetailsProgress.vue?vue&type=style&index=0&id=2b5debc2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5debc2",
  null
  
)

export default component.exports
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTimeline,QTimelineEntry});
